import React from "react";

export const WalletEndOfDayOption = ({ reportType, customerIds, checked, onChange, t = (value) => value }) => (
  reportType === "forex-deposit-details" && !customerIds ? (
    <div className="form-check mt-3">
      <input id="wallet-eod-total" className="form-check-input" type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} />
      <label className="form-check-label" htmlFor="wallet-eod-total">{t("Include Date To end-of-day wallet totals in export")}</label>
      <div className="text-muted small">{t("One total per currency. Completed days only, UTC+3.")}</div>
    </div>) : null
);
